module.exports = "data:image/gif;base64,R0lGODlhDwAOAIIAAWpsYoy3oamMQdS9fDmJdP////9tcH98XywAAAAADwAOAAIDO1gl3KxQiajGpDcOi2nZHDQZpBFliyeeReAeBSCxagrBZHEAsh7BNaACNnAFCIThr+a7MYW6g3RKVSQAADs="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/treeview/file.gif
// module id = 1969
// module chunks = 2